export enum SamplePlatePositionNamingTypes {
  Alpha = 0,
  Numeric = 1,
}
